import SideCard from './SideCard';

export default SideCard;
